

export const getToken = () => {
    return sessionStorage.getItem('token');
};

export const storeToken = (value) => {
    return sessionStorage.setItem('token', value);
};

export const removeToken = () => {
    sessionStorage.removeItem('token');
};

export const getOperator = () => {
    return sessionStorage.getItem('operator');
};

export const setOperator = (value) => {
    return sessionStorage.setItem('operator', value);
};

export const removeOperator = () => {
    sessionStorage.removeItem('operator');
};

//cookies acceptance
export const getCookiesAcceptance = () => {
    let cookies = localStorage.getItem('cookiesAccepted');
    return cookies === 'false' || !cookies ? false : true;
};

export const setCookieAccepted = () => {
    localStorage.setItem('cookiesAccepted', true);
};